export const AD_CONFIG = {
  clientId: import.meta.env.VITE_ADSENSE_CLIENT_ID || 'ca-pub-0000000000000000',
  interstitialSlot: import.meta.env.VITE_AD_SLOT_INTERSTITIAL || '0000000000',
  lobbyBannerSlot: import.meta.env.VITE_AD_SLOT_LOBBY_BANNER || '0000000000',
  sidebarSlot: import.meta.env.VITE_AD_SLOT_SIDEBAR || '0000000000',
  leaderboardSlot: import.meta.env.VITE_AD_SLOT_LEADERBOARD || '0000000000',
  gameFooterSlot: import.meta.env.VITE_AD_SLOT_GAME_FOOTER || '0000000000',
} as const;
